export default function PHP_next_result() {
  return (
    <div>
      <h1>PHP_next_result</h1>
    </div>
  );
}
